module.exports = {"150121100":"察素齐镇","150121101":"毕克齐镇","150121102":"善岱镇","150121103":"台阁牧镇","150121104":"白庙子镇","150121105":"沙尔沁镇","150121106":"敕勒川镇","150121207":"北什轴乡","150121208":"塔布赛乡","150121401":"呼和浩特金山经济技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150121.json
// module id = 483
// module chunks = 0